export default __webpack_public_path__ + "static/media/Training & Competition Day flyer.fe4b5395.pdf";